import React from "react";
import { Route, Switch } from "react-router-dom";
import AdminStartScreen from "../Dashboard/AdminStartScreen";

// Component wrappers for different views
const AdminReports = () => <AdminStartScreen activeView="reports" />;
const AdminSettings = () => <AdminStartScreen activeView="settings" />;
const AdminTools = () => <AdminStartScreen activeView="tools" />;
const AdminOverview = () => <AdminStartScreen activeView="overview" />;

const AdminRoute = ({ match }) => {
  return (
    <Switch>
      <Route path={`${match.path}/reports`} component={AdminReports} />
      <Route path={`${match.path}/settings`} component={AdminSettings} />
      <Route path={`${match.path}/tools`} component={AdminTools} />
      <Route path={`${match.path}`} component={AdminOverview} />
    </Switch>
  );
};

// AdminRoute expects match prop from React Router

export default AdminRoute;
